import React from "react";
import { Router, Route, Switch } from "react-router-dom";
import { Container } from "reactstrap";

import Loading from "./components/Loading";
import NavBar from "./components/NavBar";
import ApiExample from "./components/ApiExample";
import { useAuth0 } from "@auth0/auth0-react";
import history from "./utils/history";

// styles
import "./App.css";

// fontawesome
import initFontAwesome from "./utils/initFontAwesome";
initFontAwesome();

const App = () => {
  const { isLoading, error } = useAuth0();

  if (error) {
    return <div>Oops... {error.message}</div>;
  }

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Router history={history}>
      <div id="app" className="d-flex flex-column h-100">
        <NavBar />
        <Container className="flex-grow-1 mt-5">
          <Switch>
            <Route path="/" exact component={Home} />
          </Switch>
        </Container>
      </div>
    </Router>
  );
};

// Simple Home component with API example
const Home = () => (
  <div className="text-center">
    <h1>Multi App</h1>
    <p className="mb-8">This is your clean starting point with Auth0 authentication ready to go!</p>
    <ApiExample />
  </div>
);

export default App;
